import { zLogRocket } from '@zoll/logrocket-react-lib'

export const identifyUserForLogRocket = (userId: string, username: string) => {
  zLogRocket.identify(userId, {
    name: username.toLowerCase(),
  })
}
